import { useEffect, useState } from 'react';
import { fetchData, wrapText, headerStyles } from './Helpers';
import { freeWImg, privateImg, professionalImg, allFundsImg, etfImg, priceHoldingImg, identifiersImg, resolveImage } from "../../images/ImageResolver";

function PliDropdown({ type, pliData }) {
  return (
    <ef-layout className="geography-layout">
      <table>
        <thead>
          <tr>
            <th>Global</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {pliData.filter(row => row.region.trim() === "Global").map((row, index) => (
            <tr key={index}>
              <td>Global</td>
              { type === "free" && <td>{row["public"]}</td> }
              { type === "private" && <td>{row["private"]}</td> }
              { type === "professional" && <td>{row["professional"]}</td> }
            </tr>
          ))}
        </tbody>
        <thead>
          <tr>
            <th>Regional</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {pliData.filter(row => row.region.trim() === "Regional").map((row, index) => (
            <tr key={index}>
              <td>{row["country"]}<ef-icon icon="info"></ef-icon></td>
              { type === "free" && <td>{row["public"]}</td> }
              { type === "private" && <td>{row["private"]}</td> }
              { type === "professional" && <td>{row["professional"]}</td> }
            </tr>
          ))}
        </tbody>
        <thead>
          <tr>
            <th>Single Country</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {pliData.filter(row => row.region.trim() === "Single Country").map((row, index) => (
            <tr key={index}>
              <td>{row["country"]}</td>
              { type === "free" && <td>{row["public"]}</td> }
              { type === "private" && <td>{row["private"]}</td> }
              { type === "professional" && <td>{row["professional"]}</td> }
            </tr>
          ))}
        </tbody>
      </table>
    </ef-layout>
  )
}

function RestrictionsDropdown({ restrictionsData }) {
  useEffect(() => {
    const grid = document.getElementById("grid");
    const columns = [
      { name: "Data Provider", field: "dataProvider", leftPinned: true, scalable: true, binding: wrapText, styles: headerStyles },
      { name: "Name of the Service", field: "service", scalable: true, binding: wrapText },
      { name: "Content Description", field: "description", scalable: true, binding: wrapText },
      { name: "Provider Policy for Redistribution", field: "policy", scalable: true, binding: wrapText },
      { name: "Data Provider Contact", field: "contact", scalable: true, binding: wrapText }
    ];
    function gridConfigured(e) {
      const core = e.detail.api.getCoreGrid();
      core.setColumnWidths([250, 400, 250, 500, 500], false);
    }

    grid.config = {
      rowHeight: 60,
      autoHideScrollbar: false,
      headerRowHeight: 60,
      columns: columns,
      dataModel: {
        data: restrictionsData
      },
      sorting: {
        sortableColumns: false,
        initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
        }
      }
    };
    grid.addEventListener('configured', gridConfigured);
  }, [restrictionsData]);

  return (
    <ef-layout className="geography-layout">
      <efx-grid id="grid" className="restrictions-grid"></efx-grid>
    </ef-layout>
  )
}

function Package({ type, pliData, geoData, restrictionsData }) {
  const [tab, setTab] = useState("pli");
  const [ddIndex, setDdIndex] = useState(0);
  return (
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setTab("pli")}></ef-tab>
        <ef-tab label="Geography" value="tab2" onClick={() => setTab("geo")}></ef-tab>
        <ef-tab label="Restrictions" value="tab3" onClick={() => setTab("restrictions")}></ef-tab>
        <ef-tab label="Endpoints" value="tab4" onClick={() => setTab("endpoints")}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {tab === "pli" &&<ef-layout>
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 1 ? 0 : 1)}>
            <ef-panel spacing>
              <img src={allFundsImg} alt="All Funds" />
              <span>All Funds</span>
              {ddIndex !== 1 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 1 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 1 && <PliDropdown type={type} pliData={pliData.filter(row => row.fundType.trim() === "All Funds")} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 2 ? 0 : 2)}>
            <ef-panel spacing>
              <img src={etfImg} alt="ETF" />
              <span>ETF</span>
              {ddIndex !== 2 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 2 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 2 && <PliDropdown type={type} pliData={pliData.filter(row => row.fundType.trim() === "ETF")} />}
        </ef-layout>}
        {tab === "geo" && <ef-layout className="geography-layout">
          <table>
            <thead>
              <tr>
                <th>Geography</th>
                <th>Region</th>
                <th>Countries</th>
              </tr>
            </thead>
            <tbody>
              {geoData.map((row, index) => (
                <tr key={index}>
                  <td>{row["geography"]}</td>
                  <td>{row["region"]}</td>
                  <td>{row["countries"]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </ef-layout>}
        {tab === "restrictions" &&<ef-layout>
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 1 ? 0 : 1)}>
            <ef-panel spacing>
              <img src={priceHoldingImg} alt="Price & Holdings" />
              <span>Price & Holdings</span>
              {ddIndex !== 1 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 1 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 1 && <RestrictionsDropdown restrictionsData={restrictionsData.filter(row => row.marketRestrictions.trim() === "Price & Holdings")} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 2 ? 0 : 2)}>
            <ef-panel spacing>
              <img src={identifiersImg} alt="Identifiers" />
              <span>Identifiers</span>
              {ddIndex !== 2 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 2 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 2 && <RestrictionsDropdown restrictionsData={restrictionsData.filter(row => row.marketRestrictions.trim() === "Identifers")} />}
        </ef-layout>}
        {tab === "endpoints" && <ef-layout className="inner-layout">
          <table>
            <thead>
              <tr>
                <th>Endpoints</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>https://api.refinitiv.com/data/funds/v1/assets</td>
              </tr>
              <tr>
                <td>https://api.refinitiv.com/data/funds/v1/assets/ref/datapoints</td>
              </tr>
              <tr>
                <td>https://api.refinitiv.com/data/funds/v1/assets/ref/lookups</td>
              </tr>
            </tbody>
          </table>
        </ef-layout>}
      </ef-layout>
    </div>
  )
}

export default function WealthPackages() {
  const [packageLayout, setPackageLayout] = useState("free");
  const [pliData, setPliData] = useState([]);
  const [geoData, setGeoData] = useState([]);
  const [restrictionsData, setRestrictionsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetchData("Lipper_Fund_PLIs"),
      fetchData("Lipper_Fund_Geography"),
      fetchData("Lipper_Fund_Restrictions")
    ]).then(([pliRes, geoRes, restrictionsRes]) => {
      setPliData(pliRes);
      setGeoData(geoRes);
      setRestrictionsData(restrictionsRes);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    const buttonBar = document.getElementById('wealthBar');
    buttonBar.addEventListener('click', (event) => {
      let buttonId = '';
      if(event.target.getAttribute('id')) {
        buttonId = event.target.getAttribute('id');
      }else {
        buttonId = event.target.parentElement.getAttribute('id');
      }
      const buttons = buttonBar.querySelectorAll('ef-button');
      buttons.forEach(btn => {
        btn.active = false;
        btn.children[0].src = resolveImage(btn.getAttribute('id'));
      });
      const btn = document.getElementById(buttonId);
      btn.active = true;
      btn.children[0].src = resolveImage(`${buttonId}-w`);
      setPackageLayout(buttonId);
    });
  }, []);

  return (
    <div className='wealth-packages lipper-wealth'>
      <ef-loader class="loader" hidden={!loading}></ef-loader>
      <h4>WEALTH PACKAGES</h4>
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              <ef-button id="free" toggles active><img src={freeWImg} alt="Public"/>Public - Non Professional</ef-button>
              <ef-button id="private" toggles><img src={privateImg} alt="Private"/>Private - Non Professional</ef-button>
              <ef-button id="professional" toggles><img src={professionalImg} alt="Professional"/>Internal Professional - Private</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      {packageLayout === "free" && <Package type="free" pliData={pliData} geoData={geoData} restrictionsData={restrictionsData} />}
      {packageLayout === "private" && <Package type="private" pliData={pliData} geoData={geoData} restrictionsData={restrictionsData} />}
      {packageLayout === "professional" && <Package type="professional" pliData={pliData} geoData={geoData} restrictionsData={restrictionsData} />}
    </div>
  );
}